export default class CoreConfigRegistry {

    constructor() {
        this.registry = new Map();
    }

    setConfig(pluginName, configName, config) {
        let pluginConfigs = this.registry.get(pluginName) || new Map();
        pluginConfigs.set(configName, config);
        this.registry.set(pluginName, pluginConfigs);

        return this;
    }

    getConfig(pluginName, configName) {
        const pluginConfigs = this.registry.get(pluginName);
        if (configName) {
            if (pluginConfigs && pluginConfigs.has(configName)) {
                return pluginConfigs.get(configName);
            }
            return undefined;
        }

        return pluginConfigs || new Map();
    }

    deleteConfig(pluginName, configName) {
        const pluginConfigs = this.registry.get(pluginName);
        if (pluginConfigs) {
            pluginConfigs.delete(configName);
        }

        return this;
    }
}

